import type { VacationClientPanelProps } from './vacationClientPanel.types';
import { ClientPanelCard } from './components/ClientPanelCard';

export function VacationClientPanel({
    groups,
    year,
    showOnlyOverlaps,
    onOpenRequest,
    initiallyExpanded = false,
}: VacationClientPanelProps) {
    if (groups.length === 0) {
        return (
            <div className="rounded-lg border border-raro-gray-200 bg-raro-gray-50 p-6 text-center">
                <p className="text-sm text-raro-gray-500 font-montserrat">
                    {showOnlyOverlaps
                        ? `Nenhum conflito de cobertura em ${year}.`
                        : `Nenhuma férias agendada ou pendente em ${year}.`}
                </p>
            </div>
        );
    }

    return (
        <div className="space-y-4">
            {groups.map((group, index) => (
                <ClientPanelCard
                    key={group.clientId}
                    group={group}
                    onOpenRequest={onOpenRequest}
                    initiallyExpanded={initiallyExpanded && index === 0}
                />
            ))}
        </div>
    );
}
